import { DefaultTheme } from 'styled-components';
import colors from '@/common/view/colors';
import typescales from '@/common/view/typescales';

export const theme: DefaultTheme = {
  colors,
  typescales,
};
